import { NgModule } from '@angular/core';
import { IonicPageModule } from 'ionic-angular';
import { CguPage } from './cgu';

@NgModule({
  declarations: [
    CguPage,
  ],
  imports: [
    IonicPageModule.forChild(CguPage),
  ],
})
export class CguPageModule {}



// WEBPACK FOOTER //
// ./src/pages/cgu/cgu.module.ts